import { connect } from 'react-redux'

import PositionsTable from '../components/PositionsTable'
import { RootState } from '../types'
import { ModifyTrade, TradeCommandType, TradeType } from '@bdswiss/mt4-connector'
import { TradingAction, selectPosition, openEditPane } from '../actions'
import {
  cancelPendingOrder,
  inputPositionPrice,
  modifyTrade,
  inputPositionSL,
  inputPositionTP,
} from '../actions/TradeActions'
import { setModal } from '../actions/dialogActions'
import { I18n } from 'react-redux-i18n'
import { setTradingSymbol, setChartMode } from '../actions/commonActions'
import { updateFavourites } from '../actions/GraphQLActions'
import { MT4Connector } from '@bdswiss/mt4-connector'
import { Dispatch } from 'redux'

const mt4 = MT4Connector.Instance

export function mapStateToProps(rootState: RootState) {
  const state = rootState.appState
  return {
    isPending: true,
    currency: state.currency,
    locale: rootState.appConfig.locale
      ? rootState.appConfig.locale
      : rootState.tradingAccounts.viewer.locale,
    assets: mt4.assets, // rootState.symbolsSubscriptions,
    positions: Array.from(mt4.pendingOrders.values()), // rootState.pendingOrders,
    positionsInputs: rootState.positionsInputs,
    accountLoaded: state.accountLoaded,
    tradeOperationEnabled: rootState.tradingPane.tradeOperationEnabled,
    selectedOrder: state.selectedOrder,
    favourites: rootState.favourites,
  }
}

export function mapDispatchToProps(dispatch: Dispatch<TradingAction>) {
  return {
    onModifyTrade: ({ order, uuid, sl, tp, price }: ModifyTrade, tradeType: TradeType) =>
      dispatch(modifyTrade(order, uuid, sl, tp, tradeType, price)),
    onCloseTrade: (order: number, uuid?: string) =>
      dispatch(
        setModal(
          I18n.t(`cancelingPosition`),
          I18n.t('cancelPositionMessage'),
          cancelPendingOrder(order, uuid)
        )
      ),
    onSelectPosition: (order: number, expanded?: boolean) =>
      dispatch(selectPosition(order, expanded)),
    onInputPrice: (order: number, value: number) => dispatch(inputPositionPrice(order, value)),
    onInputStopLoss: (order: number, value: number) => dispatch(inputPositionSL(order, value)),
    onInputTakeProfit: (order: number, value: number) => dispatch(inputPositionTP(order, value)),
    onShowChart: (symbol: string, tradeType: TradeCommandType) =>
      dispatch(setTradingSymbol(symbol, tradeType)),
    onSetChartMode: () => dispatch(setChartMode('pending')),
    onOpenEditPane: () => dispatch(openEditPane()),
    onToggleFavourite: (favourites: string[]) => dispatch(updateFavourites(favourites)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PositionsTable)
